import { createSlice } from '@reduxjs/toolkit';

export interface HeaderSearchState {
  shouldFocusMobileSearch: boolean;
}

const initialState: HeaderSearchState = {
  shouldFocusMobileSearch: false
};

const headerSearchSlice = createSlice({
  name: 'headerSearch',
  initialState,
  reducers: {
    requestMobileSearchFocus: (state) => {
      state.shouldFocusMobileSearch = true;
    },
    clearMobileSearchFocus: (state) => {
      state.shouldFocusMobileSearch = false;
    }
  }
});

export const { requestMobileSearchFocus, clearMobileSearchFocus } =
  headerSearchSlice.actions;

export default headerSearchSlice.reducer;
